import React, { Component } from "react";
import { connect, Field } from "react-redux";

import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import Header from "../common/AuthHeader";
import { postServerDataWithPath } from "../../../action/common_action";
import { axiosInstnace, getLocalData } from "../../../util/util";
import { endPoints, url } from "../../../config";
import DSATermsPopup from "./termsandcond";
import { history } from "../../../history/history";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-toastify/dist/ReactToastify.css";
import { getState } from "../../../action/user_action";
import moment from "moment";
import Axios from "axios";

class DsaIncenticeTermsandCond extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      prevVersion: false,
      salesuser: getLocalData("salesUserInfo"),
      firstorder: "",
      repeatordersamemonth: "",
      repeatordersubsmonth: "",
      minOrder: "",
      minimumOrderValue: "",
      maxOrder: "",
      lowvolume: "",
      highvolume: "",
      effectivedate: "",
      enddate: "",
      history: [],
    };
  }

  //Check date for kyc
  componentDidMount = async () => {
    let station = this.state.salesuser.station;
    let data = await axiosInstnace.get(endPoints.getdsaconfig, {
      params: {
        station,
      },
    });
    let conf = data.data.data[0];
    this.setState({ ...this.state, ...conf });
  };

  render() {
    let { kycDetails, uploadedFileArr } = this.state;
    return (
      <div className="main_wrapper">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper create_camp_container">
          <div className="right_wrapper_inner">
            <Header />
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner detail_content">
                <div className="create_kyc_wrapper">
                  {this.state.history.length > 1 && (
                    <div class="print_btn" style={{ textAlign: "right" }}>
                      <select
                        class="packageType drop-down-icon"
                        onChange={(e) => {
                          let data = this.state.history[e.target.value];
                          this.setState({
                            prevVersion: true,
                            firstorder: data.firstorder,
                            repeatordersamemonth: data.repeatordersamemonth,
                            repeatordersamemonth: data.repeatordersamemonth,
                            minOrder: data.minOrder,
                            // minimumOrderValue: data.minimumOrderValue,
                            maxOrder: data.maxOrder,
                            lowvolume: data.lowvolume,
                            highvolume: data.highvolume,
                            effectivedate: data.startdate,
                            enddate: data.enddate,
                          });
                        }}
                      >
                        <option> Refer Previous Versions</option>
                        {this.state.history.map((e, index) => {
                          return (
                            <option value={index}> V- 00{index + 1} </option>
                          );
                        })}
                      </select>
                      {this.state.prevVersion && (
                        <button
                          style={{ marginLeft: "35px" }}
                          onClick={(e) => window.location.reload()}
                        >
                          {" "}
                          Back{" "}
                        </button>
                      )}
                    </div>
                  )}
                  <h2 className="detail_kyc_header">
                    Trade partner incentive Terms & Conditions with effect from{" "}
                    {moment(this.state.effectivedate).format("DD MMM YYYY")}
                    {this.state.enddate && " to "}
                    {this.state.enddate &&
                      moment(this.state.enddate).format("DD MMM YYYY")}
                  </h2>

                  <div className="kycdetails_wrapper">
                    <ol>
                      <li
                        style={{
                          listStyle: "decimal",
                          margin: "10px",
                          textAlign: "justify",
                          fontSize: "18px",
                        }}
                      >
                        <p>
                          Once a new advertiser is onboarded through the Trade
                          Partner, Trade Partner will get a{" "}
                          {this.state.firstorder}% incentive on the 1st order as
                          well as all the repeat orders placed by the new
                          advertiser within the same calendar month.
                        </p>
                      </li>
                      <li
                        style={{
                          listStyle: "decimal",
                          margin: "10px",
                          textAlign: "justify",
                          fontSize: "18px",
                        }}
                      >
                        <p>
                          For all the subsequent orders placed by the same
                          advertiser, Trade Partner will get a repeat order
                          incentive of {this.state.repeatordersubsmonth}% from
                          month 2 onwards up to the last day of month {this.state.incentiveCalculationMaxTimeperiod} provided
                          trade Partner continues to log a minimum volume of{" "}
                          {this.state.minOrder} orders per month (new or repeat
                          customers) and a minimum campaign value of{" "}
                          {this.state.minimumOrderValue} per month. Trade
                          Partners who maintain such minimum volume and minimum
                          campaign value per month would be categorised with a
                          performance grade named as <b>“Silver”</b> which will
                          be displayed on the{" "}
                          <a
                            target="_blank"
                            href="https://buyadsonbigfm.com/tp/login"
                          >
                            https://buyadsonbigfm.com/tp/login
                          </a>{" "}
                          page.
                        </p>
                      </li>
                      <li
                        style={{
                          listStyle: "decimal",
                          margin: "10px",
                          textAlign: "justify",
                          fontSize: "18px",
                        }}
                      >
                        <p>
                          In case during any month (month 2 to month {this.state.incentiveCalculationMaxTimeperiod}) Trade
                          Partner is not able to log a minimum volume of{" "}
                          {this.state.minOrder} orders per month AND minimum
                          campaign value per month of{" "}
                          {this.state.minimumOrderValue}, then repeat order
                          incentive will be reduced to {this.state.lowvolume}%
                          from next month onwards. Trade Partners who fail to
                          maintain such minimum volume and minimum campaign
                          value per month would be categorised with a
                          performance grade named as <b>“Bronze”</b> which will
                          be displayed on the{" "}
                          <a
                            target="_blank"
                            href="https://buyadsonbigfm.com/tp/login"
                          >
                            https://buyadsonbigfm.com/tp/login
                          </a>{" "}
                          page.{" "}
                        </p>
                      </li>
                      <li
                        style={{
                          listStyle: "decimal",
                          margin: "10px",
                          textAlign: "justify",
                          fontSize: "18px",
                        }}
                      >
                        <p>
                          If any Trade Partner logs {this.state.maxOrder} or
                          more orders per month AND a minimum campaign value of{" "}
                          {this.state.maximumOrderValue} the  n repeat order
                          incentive of such Trade Partner will be{" "}
                          {this.state.highvolume}% from next calendar month
                          onwards. Trade Partners who achieve such performance
                          would be categorised with a performance grade named as{" "}
                          <b>“Gold”</b> which will be displayed on the{" "}
                          <a
                            href="https://buyadsonbigfm.com/tp/login"
                            target="_blank"
                          >
                            https://buyadsonbigfm.com/tp/login
                          </a>{" "}
                          page.
                        </p>
                      </li>
                      <li
                        style={{
                          listStyle: "decimal",
                          margin: "10px",
                          textAlign: "justify",
                          fontSize: "18px",
                        }}
                      >
                        <p>
                          Trade Partner must generate the invoice before 7th of
                          every calendar month towards the incentive earned
                          during the previous month using the "Invoice
                          Generation" module of the <a
                            href="https://buyadsonbigfm.com/tp/login"
                            target="_blank"
                          >
                            buyadsonbigfm.com/tp/login
                          </a>
                          {" "}portal. Trade partner must download the copy of the
                          invoice generated using "Payout Details > Invoice copy
                          download" and print the same on paper and get the same duly signed by authorized signatory. Post signature the Invoice must be couriered to <b>{this.state.baseAddress} </b>  to reach us within 15 days from the date of invoice.
                          Trade Partner can also submit the invoices post
                          signing it with legally valid digital signature (class
                          2) and email the same to {" "}
                          <a target="_blank" href="mailto:tpsupport@buyadsonbigfm.com">tpsupport@buyadsonbigfm.com</a>
                          {" "}
                          to reach within 15 days from date of invoice.
                          </p>
                      </li>
                      <li
                        style={{
                          listStyle: "decimal",
                          margin: "10px",
                          textAlign: "justify",
                          fontSize: "18px",
                        }}
                      >
                        <p>
                          Accrued incentives will be paid to You within 45
                          (Forty Five) calendar days post invoice date subject
                          to the terms mentioned in clause 5 above and any
                          statutory or other deductions applicable. In case GST
                          is charged on the invoices then the payments will be
                          subject to Trade Partner making the GST payment,
                          filing of GST return and reflection of GST credit on
                          the GST portal.
                        </p>
                      </li>
                      <li
                        style={{
                          listStyle: "decimal",
                          margin: "10px",
                          textAlign: "justify",
                          fontSize: "18px",
                        }}
                      >
                        <p>
                          Trade partner must ensure that the advertiser who is
                          booking the campaign through his reference, enters
                          the Trade Partner's login id used to login to the{" "}
                          <a
                            href="https://buyadsonbigfm.com/tp/login"
                            target="_blank"
                          >
                            buyadsonbigfm.com/tp/login
                          </a>{" "}
                          portal as the "BIG FM Sales Representative ID" while
                          booking the advertisement campaign on{" "}
                          <a
                            href="https://buyadsonbigfm.com/tp/login"
                            target="_blank"
                          >
                            buyadsonbigfm.com/tp/login
                          </a>{" "}
                          website. If the advertiser fails to enter this id then
                          the trade partner will not be liable to receive any
                          incentive towards that campaign.
                        </p>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.handletermsandcondpopup && (
            <DSATermsPopup
              isShowing={true}
              acceptterms={this.acceptterms}
              hide={this.declineterms}
            />
          )}
        </div>
        <ToastContainer />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateKycDetails: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(DsaIncenticeTermsandCond);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/tersandcondpage.js